/* eslint-disable @next/next/no-img-element */
//components
import { Container } from '@/components/Grid';

//miranda button
import { MirandaBrandButton } from '@/components/Button/BaseButton';

//styles
import {
  SideCTAWrapper,
  ImageSpacer,
  ContentHolder,
  FooterContent,
  Title,
  Description,
} from './SideCTA.styles';

export function SideCTA({ content }) {
  return (
    <>
      <SideCTAWrapper>
        <Container>
          <ImageSpacer role="presentation">
            <img src="/images/managed-transportation/mt-side-xxlg.jpg" alt="" />
          </ImageSpacer>
          <ContentHolder>
            <Title as="h2">
              The freight market is dynamic,{' '}
              <strong>are you agile enough to take advantage of it?</strong>
            </Title>
            <Description as="p">
              We combine human and machine intelligence to help you stay on top
              of a dynamic market. With unparalleled market visibility,
              Loadsmart creates a robust network strategy that balances
              near-term predictability and long-term adaptability.
            </Description>
            <FooterContent>
              <MirandaBrandButton as="a" href="#hubspot-form">
                Schedule your assessment
              </MirandaBrandButton>
            </FooterContent>
          </ContentHolder>
        </Container>
      </SideCTAWrapper>
    </>
  );
}
